module.exports = __webpack_public_path__ + "img/diaNaranja.56f0ca8f.jpg";